
import { Component, Vue, Emit } from 'vue-property-decorator'

@Component({})
export default class OrderFilter extends Vue {
  sortBy: boolean = false
  filterBy: boolean = false
  filters: any = {
    qs: '',
    ordering: '',
    sort_by: '',
    status: '',
  }
  statuses: Object[] = [
    { id: 5, status: this.$t('filters.pending') as string },
    { id: 16, status: this.$t('filters.confirmed') as string },
    { id: 12, status: this.$t('filters.rejected') as string },
    { id: 20, status: this.$t('filters.shiped') as string },
    { id: 19, status: this.$t('filters.delivered') as string },
    { id: 15, status: this.$t('filters.draft') as string },
  ]
  sortFields: Object[] = [
    { id: 1, name: this.$t('id') as string, value: 'id' },
    { id: 2, name: this.$t('date') as string, value: 'date' },
    { id: 3, name: this.$t('value') as string, value: 'value' },
  ]
  orderings: Object[] = [
    { id: 1, name: this.$t('filters.ascending') as string, value: 'asc' },
    { id: 2, name: this.$t('filters.descending') as string, value: 'desc' },
  ]

  toggleSortBy() {
    this.sortBy = !this.sortBy
  }

  toggleFilterBy() {
    this.filterBy = !this.filterBy
  }

  hideFilters() {
    this.sortBy = false
    this.filterBy = false
  }

  @Emit('selected-filters')
  selectedFilters() {
    return this.filters
  }

  @Emit('selected-filters')
  clearSort() {
    this.filters.ordering = ''
    this.filters.sort_by = ''
    return this.filters
  }

  @Emit('selected-filters')
  clearFilter() {
    this.filters.status = ''
    return this.filters
  }
}
